export const CHECK_ZIPCODE_SUCCESSFULLY = 'CHECK_ZIPCODE_SUCCESSFULLY';
export const CHECK_ZIPCODE_FAILED = 'CHECK_ZIPCODE_FAILED';

export const GET_PREFERRED_DAYS_SUCCESSFULLY = 'GET_PREFERRED_DAYS_SUCCESSFULLY';
export const GET_PREFERRED_DAYS_FAILED = 'GET_PREFERRED_DAYS_FAILED';

export const ENQUIRY_SUCCESSFULLY = 'ENQUIRY_SUCCESSFULLY';
export const ENQUIRY_FAILED = 'ENQUIRY_FAILED';

export const GET_PRICE_LIST_SUCCESSFULLY = 'GET_PRICE_LIST_SUCCESSFULLY';
export const GET_PRICE_LIST_FAILED = 'GET_PRICE_LIST_FAILED';

export const GET_QUOTE_SUCCESSFULLY = 'GET_QUOTE_SUCCESSFULLY';
export const GET_QUOTE_FAILED = 'GET_QUOTE_FAILED';

export const POST_SERVICE_ORDER_SUCCESSFULLY = 'POST_SERVICE_ORDER_SUCCESSFULLY';
export const POST_SERVICE_ORDER_FAILED = 'POST_SERVICE_ORDER_FAILED';

export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_FULFILLED = 'LOGIN_FULFILLED';
export const LOGIN_REJECTED = 'LOGIN_REJECTED';

export const GET_USER_REQUESTED = 'GET_USER_REQUESTED';
export const GET_USER_FULFILLED = 'GET_USER_FULFILLED';
export const GET_USER_REJECTED = 'GET_USER_REJECTED';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';


export const RESET_PASSWORD_REJECTED = 'RESET_PASSWORD_REJECTED';
export const RESET_PASSWORD_REQUESTED = 'RESET_PASSWORD_REQUESTED';
export const RESET_PASSWORD_FULFILLED = 'RESET_PASSWORD_FULFILLED';

export const REGISTER_USER_REQUESTED = 'REGISTER_USER_REQUESTED';
export const REGISTER_USER_FULFILLED = 'REGISTER_USER_FULFILLED';
export const REGISTER_USER_REJECTED = 'REGISTER_USER_REJECTED';

export const VERIFY_EMAIL_REQUESTED = 'VERIFY_EMAIL_REQUESTED';
export const VERIFY_EMAIL_FULFILLED = 'VERIFY_EMAIL_FULFILLED';
export const VERIFY_EMAIL_REJECTED = 'VERIFY_EMAIL_REJECTED';

export const UPDATE_SERVICE_ORDER_SUCCESSFULLY = 'UPDATE_SERVICE_ORDER_SUCCESSFULLY';
export const UPDATE_SERVICE_ORDER_FAILED = 'UPDATE_SERVICE_ORDER_FAILED';

export const CLEAR_PRICING_CALC = 'CLEAR_PRICING_CALC';

export const UPDATE_LAST_STEP_SUCCESSFULLY = 'UPDATE_LAST_STEP_SUCCESSFULLY';
export const UPDATE_LAST_STEP_FAILED = 'UPDATE_LAST_STEP_FAILED';
export const REGISTER_LAST_STEP_SUCCESSFULLY = "REGISTER_LAST_STEP_SUCCESSFULLY";
export const REGISTER_LAST_STEP_FAILED = "REGISTER_LAST_STEP_FAILED";
export const GET_LAST_STEP_UUID_SUCCESSFULLY = "GET_LAST_STEP_UUID_SUCCESSFULLY";
export const GET_LAST_STEP_UUID_FAILED = "GET_LAST_STEP_UUID_FAILED";

// Email validation
export const CHECK_EMAIL = 'CHECK_EMAIL';
export const VERIFY_EMAIL_FAILED = 'VERIFY_EMAIL_FAILED,';
export const VERIFY_EMAIL_SUCCESSFULLY = 'VERIFY_EMAIL_SUCCESSFULLY,';

// Account info
export const GET_LOGIN_USER_DETAILS = 'GET_LOGIN_USER_DETAILS';
export const GET_LOGIN_USER_DETAILS_FAILED = 'GET_LOGIN_USER_DETAILS_FAILED';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_USER_DETAILS_FAILED = 'UPDATE_USER_DETAILS_FAILED';
export const GET_NITIFICATION_PREFERENCE_LIST = 'GET_NITIFICATION_PREFERENCE_LIST';
export const GET_NITIFICATION_PREFERENCE_LIST_FAILED = 'GET_NITIFICATION_PREFERENCE_LIST_FAILED';
export const UPDATE_NITIFICATION_PREFERENCE = 'UPDATE_NITIFICATION_PREFERENCE';
export const UPDATE_NITIFICATION_PREFERENCE_FAILED = 'UPDATE_NITIFICATION_PREFERENCE_FAILED';
export const GET_COMMUNITY_INFO_DETAILS_SUCCESSFULLY = 'GET_COMMUNITY_INFO_DETAILS_SUCCESSFULLY';
export const GET_COMMUNITY_INFO_FAILED = 'GET_COMMUNITY_INFO_FAILED';
export const UPDATE_COMMUNITY_INFO_DETAILS_SUCCESSFULLY = 'UPDATE_COMMUNITY_INFO_DETAILS_SUCCESSFULLY';
export const UPDATE_COMMUNITY_INFO_FAILED = 'UPDATE_COMMUNITY_INFO_FAILED';
export const GET_PAYMENT_DETAILS_SUCCESSFULLY = 'GET_PAYMENT_DETAILS_SUCCESSFULLY';
export const GET_PAYMENT_DETAILS_FAILED = 'GET_PAYMENT_DETAILS_FAILED';

// Dog info
export const ADD_DOG = 'ADD_DOG';
export const ADD_DOG_FAILED = 'ADD_DOG_FAILED';
export const GET_DOG_LIST = 'GET_DOG_LIST';
export const GET_DOG_LIST_FAILED = 'GET_DOG_LIST_FAILED';
export const UPDATE_DOG = 'UPDATE_DOG';
export const UPDATE_DOG_FAILED = 'UPDATE_DOG_FAILED';
export const DELETE_DOG = 'DELETE_DOG';
export const DELETE_DOG_FAILED = 'DELETE_DOG_FAILED';

//Invoice
export const GET_ACCOUNT_LISTING_SUCCESSFULLY = 'GET_ACCOUNT_LISTING_SUCCESSFULLY';
export const GET_ACCOUNT_LISTING_FAILED = 'GET_ACCOUNT_LISTING_FAILED';

// Messages
export const GET_MESSAGES_LIST = 'GET_MESSAGES_LIST';
export const GET_MESSAGES_LIST_FAILED = 'GET_MESSAGES_LIST_FAILED';
export const CREATE_NEW_TICKET = 'CREATE_NEW_TICKET';
export const CREATE_NEW_TICKET_FAILED = 'CREATE_NEW_TICKET_FAILED';
export const MESSAGE_REPLAY = 'MESSAGE_REPLAY';
export const MESSAGE_REPLAY_FAILED = 'MESSAGE_REPLAY_FAILED';
export const CLOSE_TICKET = 'CLOSE_TICKET';
export const CLOSE_TICKET_FAILED = 'CLOSE_TICKET_FAILED';
export const MESSAGE_COUNT = 'MESSAGE_COUNT';
export const MESSAGE_COUNT_FAILED = 'MESSAGE_COUNT_FAILED';
export const GET_REASON_LIST = 'GET_REASON_LIST';
export const GET_REASON_LIST_FAILED = 'GET_REASON_LIST_FAILED';
//Billing info
export const ADD_NEW_CARD = 'ADD_NEW_CARD';
export const ADD_NEW_CARD_FAILED = 'ADD_NEW_CARD_FAILED';
export const GET_CARD_LIST = 'GET_CARD_LIST';
export const GET_CARD_LIST_FAILED = 'GET_CARD_LIST_FAILED';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_CARD_FAILED = 'UPDATE_CARD_FAILED';
export const DELETE_CARD = 'DELETE_CARD';
export const DELETE_CARD_FAILED = 'DELETE_CARD_FAILED';
export const GET_BILLING_INFO = 'GET_BILLING_INFO';
export const GET_BILLING_INFO_FAILED ='  GET_BILLING_INFO_FAILED';

// commercial Quote
export const ADD_COMMERCIAL_QUOTE_REQUESTED = 'ADD_COMMERCIAL_QUOTE_REQUESTED';
export const ADD_COMMERCIAL_QUOTE_FULFILLED = 'ADD_COMMERCIAL_QUOTE_FULFILLED';
export const ADD_COMMERCIAL_QUOTE_REJECTED = 'ADD_COMMERCIAL_QUOTE_REJECTED';
export const UPDATE_COMMERCIAL_QUOTE = 'UPDATE_COMMERCIAL_QUOTE';
export const UPDATE_COMMERCIAL_QUOTE_FAILED = 'UPDATE_COMMERCIAL_QUOTE_FAILED';
export const GET_COMMERCIAL_PROPOSAL = 'GET_COMMERCIAL_PROPOSAL';
export const GET_COMMERCIAL_PROPOSAL_FAILED = 'GET_COMMERCIAL_PROPOSAL_FAILED';
export const GET_PROPOSAL_SUCCESSFULLY = 'GET_PROPOSAL_SUCCESSFULLY';
export const GET_PROPOSAL_FAILED = 'GET_PROPOSAL_FAILED';

// commercial proposal
export const ADD_COMMERCIAL_PROPOSAL = 'ADD_COMMERCIAL_PROPOSAL';
export const ADD_COMMERCIAL_PROPOSAL_FAILED = 'ADD_COMMERCIAL_PROPOSAL_FAILED';
export const UPDATE_COMMERCIAL_PROPOSAL = 'UPDATE_COMMERCIAL_PROPOSAL';
export const UPDATE_COMMERCIAL_PROPOSAL_FAILED = 'UPDATE_COMMERCIAL_PROPOSAL_FAILED';
export const GET_COMMERCIAL_PROPOSALS_SUCCESSFULLY = 'GET_COMMERCIAL_PROPOSALS_SUCCESSFULLY';
export const GET_COMMERCIAL_PROPOSALS_FAILED = 'GET_COMMERCIAL_PROPOSALS_FAILED';

// commercial inner proposal
export const ADD_INNER_COMMERCIAL_PROPOSAL = 'ADD_INNER_COMMERCIAL_PROPOSAL';
export const ADD_INNER_COMMERCIAL_PROPOSAL_FAILED = 'ADD_INNER_COMMERCIAL_PROPOSAL_FAILED';
export const UPDATE_INNER_COMMERCIAL_PROPOSAL = 'UPDATE_INNER_COMMERCIAL_PROPOSAL';
export const UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED = 'UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED';

export const RESET_PROPOSAL = 'RESET_PROPOSAL';

//service
export const GET_SERVICE_ORDER_LIST = 'GET_SERVICE_ORDER_LIST';
export const GET_SERVICE_ORDER_LIST_FAILED = 'GET_SERVICE_ORDER_LIST_FAILED';
export const VIEW_SERVICE = 'VIEW_SERVICE';
export const VIEW_SERVICE_FAILED = 'VIEW_SERVICE_FAILED';
export const PAUSE_SERVICE = 'PAUSE_SERVICE';
export const PAUSE_SERVICE_FAILED = 'PAUSE_SERVICE_FAILED';
export const GET_PAUSE_SERVICE = 'GET_PAUSE_SERVICE';
export const GET_PAUSE_SERVICE_FAILED = 'GET_PAUSE_SERVICE_FAILED';
export const DELETE_PAUSE_SERVICE = 'DELETE_PAUSE_SERVICE';
export const DELETE_PAUSE_SERVICE_FAILED = 'DELETE_PAUSE_SERVICE_FAILED';
export const GET_PAST_UPCOMING_SERVICE = 'GET_PAST_UPCOMING_SERVICE';
export const GET_PAST_UPCOMING_SERVICE_FAILED = 'GET_PAST_UPCOMING_SERVICE_FAILED';
export const ADD_REVIEW = 'ADD_REVIEW';
export const ADD_REVIEW_FAILED = 'ADD_REVIEW_FAILED';
export const ADD_BAG = 'ADD_BAG';
export const ADD_BAG_FAILED = 'ADD_BAG_FAILED';
export const GET_SERVICE_ORDER_ENQUIRY_SUCCESSFULLY = 'GET_SERVICE_ORDER_ENQUIRY_SUCCESSFULLY';
export const GET_SERVICE_ORDER_ENQUIRY_FAILED = 'GET_SERVICE_ORDER_ENQUIRY_FAILED';

// Residential
export const GET_LEAD_FAILED = 'GET_LEAD_FAILED';
export const GET_LEAD_SUCCESSFULLY = 'GET_LEAD_SUCCESSFULLY';
export const CREATE_LEAD_SUCCESSFULLY = 'CREATE_LEAD_SUCCESSFULLY';
export const CREATE_LEAD_FAILED = 'CREATE_LEAD_FAILED';
export const RESIDENTIAL_REGISTER_SUCCESSFULLY = 'RESIDENTIAL_REGISTER_SUCCESSFULLY';
export const RESIDENTIAL_REGISTER_FAILED = 'RESIDENTIAL_REGISTER_FAILED';
export const UPDATE_LEAD_SUCCESSFULLY = 'UPDATE_LEAD_SUCCESSFULLY';
export const UPDATE_LEAD_FAILED = 'UPDATE_LEAD_FAILED';
export const CLEAN_RESIDENTIAL_REGISTER_RESPONSE = 'CLEAN_RESIDENTIAL_REGISTER_RESPONSE';

//Proposal
export const GET_RESIDENTIAL_PROPOSALS_SUCCESSFULLY = 'GET_RESIDENTIAL_PROPOSALS_SUCCESSFULLY';
export const GET_RESIDENTIAL_PROPOSALS_FAILED = 'GET_RESIDENTIAL_PROPOSALS_FAILED';
export const GET_COMMERICAL_USER_SUCCESSFULLY = 'GET_COMMERICAL_USER_SUCCESSFULLY';
export const GET_COMMERICAL_USER_FAILED = 'GET_COMMERICAL_USER_FAILED';
export const PRINT_INVOICE = 'PRINT_INVOICE';
export const PRINT_INVOICE_FAILED = 'PRINT_INVOICE_FAILED';

// account overview map
export const SERVICE_STATS = 'SERVICE_STATS';
export const SERVICE_STATS_FAILED = 'SERVICE_STATS_FAILED';

// get geocode
export const GET_GEOCODE = 'GET_GEOCODE';
export const GET_GEOCODE_FAILED = 'GET_GEOCODE_FAILED';
export const POST_SERVICE_ORDER_INQUIRY_SUCCESSFULLY = 'POST_SERVICE_ORDER_INQUIRY_SUCCESSFULLY';
export const POST_SERVICE_ORDER_INQUIRY_FAILED = 'POST_SERVICE_ORDER_INQUIRY_FAILED';
export const UPDATE_SERVICE_ORDER_INQUIRY_SUCCESSFULLY = 'UPDATE_SERVICE_ORDER_INQUIRY_SUCCESSFULLY';
export const UPDATE_SERVICE_ORDER_INQUIRY_FAILED = 'UPDATE_SERVICE_ORDER_INQUIRY_FAILED';

// get Credit-memo/Invoice List
export const GET_INVOICE_CREDIT_MEMO_LIST = 'GET_INVOICE_CREDIT_MEMO_LIST';
export const GET_INVOICE_CREDIT_MEMO_LIST_FAILED = 'GET_INVOICE_CREDIT_MEMO_LIST_FAILED';

//Link Payment
export const LINK_PAYMENT_SUCCESSFULLY = 'LINK_PAYMENT_SUCCESSFULLY';
export const LINK_PAYMENT_FAILED = 'LINK_PAYMENT_FAILED';

export const HISTORICAL_DATA_SUCCESS = 'HISTORICAL_DATA_SUCCESS';
export const HISTORICAL_DATA_FAILED = 'HISTORICAL_DATA_FAILED';